// import React, { Component } from "react";

// // reactstrap components
// import {
//   CardBody,
//   Table,
//   Row,
//   Col,
//   Button,
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
// } from "reactstrap";
// import API from "api.js";
// import { base, s3base } from "api.js";
// import ReactHtmlParser from "react-html-parser";
// import { setAlert } from "action/index.js";
// import { store } from "store/index";
// import ModalSkeleton from "components/PopUps/ModalSkeleton";
// import QuestionExplanationVideo from "components/PopUps/QuestionExplanationVideo";

// class ShowHistoryData extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       data: [],
//       modal: false,
//       id: 0,
//       scoreData: [],
//       openAiModal: false,
//       paragraphExplainationModal: false,
//       showBottomExplanationPopup: false,
//       videoModal: false,
//     };
//   }

//   showScore = (e, id) => {
//     console.log("id-------",id);

//     this.setState({
//       modal: !this.state.modal,
//       id: id,
//     });
//   };

//   showOpenAiScore = (e) => {
//     this.setState({
//       openAiModal: !this.state.openAiModal,
//     });
//   };

//   showExplanation = () => {
//     this.setState({ paragraphExplainationModal: true });
//   };

//   deleteComment = async (e, id) => {
//     var bodyFormData = { id: id, question_id: this.props.question };
//     let res = null;
//     try {
//       res = await API({
//         method: "Delete",
//         url: "delete/question/response",
//         data: bodyFormData,
//       });
//     } catch (error) {
//       //this.setState({error:{error} });
//     }

//     if (res) {
//       if (res.status === 200) {
//         this.props.changeResponseArr(res.data.data);
//         //this.setState({qData:res.data.data});

//         store.dispatch(
//           setAlert({ flag: true, type: 1, message: res.data.message })
//         );
//       }
//     }
//   };

//   showHistoryFunc = () => {
//     let arr = this.props.data;

//   if (!Array.isArray(arr)) {
//     console.error("Expected an array, but got:", arr);
//     return []; // or handle it as needed
//   }

//   let arr1 = arr.filter((va) => typeof va === "object");
//     console.error(arr1);
//     let a = arr1.map((v) => {
//       console.log("v==========",v);

//       return `
//         <tr>
//           <td>${this.remarks(v.type)}</td>
//           <td className="result-score-wrapper">
//             <span>${v.score}/${v.from}</span>
//           </td>
//           <td>${v.remarks}</td>
//         </tr>
//       `;
//     });
//     if ([6, 7, 13].includes(this.props.data[0].type)) {
//       let t_from = 0;
//       let t_score = 0;
//       for (var i = 0; i <= arr1.length - 1; i++) {
//         t_from += arr1[i].from;
//         t_score += arr1[i].score;
//       }
//       a.push(
//         '<tr><td>Total</td><td colspan="2">' +
//           t_score +
//           "/" +
//           t_from +
//           "</td></tr>"
//       );
//     }
//     return a;
//   };

//   remarks = (type) => {
//     let str = "";
//     switch (type) {
//       case 0:
//         str = "Content";
//         break;
//       case 1:
//         str = "Fluency";
//         break;
//       case 2:
//         str = "Pronunciation";
//         break;
//       case 3:
//         str = "Score";
//         break;
//       case 4:
//         str = "Grammar";
//         break;
//       case 5:
//         str = "Form";
//         break;
//       case 6:
//         str = "Vocabulary";
//         break;
//       case 7:
//         str = "Spelling";
//         break;
//       case 8:
//         str = "Structure";
//         break;
//       case 9:
//         str = "Linguistic range";
//         break;
//       default:
//         str = "";
//     }
//     return str;
//   };

//   otherData = () => {
//     let arr = this.props.data.map((v) => {
//       if (this.state.id === v.id) {
//         return v.score;
//       }
//     });
//     let data = this.props.data
//       .map((v) => {
//         if (this.state.id === v.id) {
//           return v;
//         }
//       })
//       .filter((va) => {
//         if (typeof va === "object") {
//           return va;
//         }
//       })[0];
//     let arr1 = arr.filter((va) => {
//       if (typeof va === "object") {
//         return va;
//       }
//     })[0];
//     let a = arr1.map((v) => {
//       return `<tr><td>${this.remarks(v.type)}</td><td>${v.score}/${
//         v.from
//       }</td><td>${v.remarks}</td></tr>`;
//     });
//     console.error(data);
//     return (
//       <div className="mt-4 text-center">
//         <h3>User Response</h3>
//         {data.html != "undefined" &&
//           data.type != 10 &&
//           ReactHtmlParser(data.html)}
//         {data.html != "undefined" &&
//           data.type == 10 &&
//           data.html
//             .split("<br />")
//             .filter((va) => {
//               if (va !== "") {
//                 return va;
//               }
//             })
//             .map((v) => {
//               return ReactHtmlParser(
//                 '<li className="list-group-item1">' + v + "</li>"
//               );
//             })}

//         {[3, 4].includes(data.type) && (
//           <div>
//             <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW">
//               <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
//                 <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>Good
//               </div>
//               <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
//                 <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJav"></div>
//                 Average
//               </div>
//               <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca"></div>
//             </div>
//           </div>
//         )}
//         {[1, 2].includes(data.type) && (
//           <div>
//             <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW">
//               <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
//                 <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>Good
//               </div>
//               <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
//                 <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJbad"></div>Bad
//                 pronunciation/Missed words
//               </div>
//               <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca"></div>
//             </div>
//           </div>
//         )}
//         {[6, 7, 13, 11, 12, 16, 19].includes(data.type) &&
//           ReactHtmlParser(data.answer)}
//         {data.file && (
//           <div>
//             <audio
//               className="mt-4"
//               src={s3base + "/ptedata/ptemedia/" + data.file}
//               controls="controls"
//             />
//           </div>
//         )}
//       </div>
//     );
//     return <div>ss</div>;
//   };

//   toggle = () => {
//     this.setState({ modal: !this.state.modal });
//   };

//   openAiToggle = () => {
//     this.setState({
//       openAiModal: !this.state.openAiModal,
//     });
//   };

//   itemLabel = (key) => {
//     const labels = {
//       content: "Content",
//       form: "Form",
//       grammar: "Grammar",
//       vocabulary: "Vocabulary",
//       linguistic: "Linguistic Range",
//       structure: "Structure",
//       spelling: "Spelling",
//       overall: "Overall Score",
//     };

//     return labels[key];
//   };

//   showRemarksWithFeedback = () => {
//     console.log(this.props.openAiRemarks);
//     const { feedback } = this.props.openAiRemarks;

//     if (feedback !== undefined && feedback !== null) {
//       let html = "";
//       Object.keys(feedback).map((key, i) => {
//         const score = this.props.openAiRemarks[key].score;
//         const out_of = this.props.openAiRemarks[key].out_of;

//         html += "<tr>";
//         html += `<td>${this.itemLabel(key)}</td>`;
//         html += `<td>${score}/${out_of}</td>`;
//         html += `<td>${feedback[key]}</td>`;
//         html += "</tr>";
//       });
//       return ReactHtmlParser(html);
//     }
//   };

//   closeVideoModal = () => {
//     this.setState({ videoModal: false });
//   };

//   showVideoModal = () => {
//     this.setState(
//       this.props.question.video
//         ? { videoModal: true }
//         : { showBottomExplanationPopup: true }
//     );
//   };

//   render() {
//     if (this.props.flag === 1) {
//       return (
//         <>
//           {this.state.modal && (
//             <Modal isOpen={this.state.modal} size="lg" className="score-popup">
//               <ModalHeader>
//                 Score with remarks{" "}
//                 <Button className="modalCloseBtn" onClick={this.toggle}>
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     viewBox="0 0 24 24"
//                     width="24"
//                     height="24"
//                   >
//                     <path
//                       d="M18 6L6 18M6 6l12 12"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </Button>
//               </ModalHeader>
//               <ModalBody>
//                 <Table>
//                   <tbody>
//                     <tr>
//                       <th>Component</th>
//                       <th>Score</th>
//                       <th>Remarks</th>
//                     </tr>
//                     {this.state.modal && (
//                       <>
//                         {this.showHistoryFunc().map((v) => {
//                           return ReactHtmlParser(v);
//                         })}
//                       </>
//                     )}
//                   </tbody>
//                 </Table>
//               </ModalBody>
//               {/*<ModalFooter>
//                 <Button
//                   color="secondary"
//                   className="modalCloseBtn"
//                   onClick={this.toggle}
//                 >
//                   Close
//                 </Button>
//               </ModalFooter>*/}
//             </Modal>
//           )}

//           {this.state.openAiModal && (
//             <Modal isOpen={this.state.openAiModal} size="lg">
//               <ModalBody>
//                 <Table>
//                   <tbody>
//                     <tr>
//                       <th>Component</th>
//                       <th>Score</th>
//                       <th>Remarks</th>
//                     </tr>
//                     {this.showRemarksWithFeedback()}
//                   </tbody>
//                 </Table>
//               </ModalBody>
//               <ModalFooter>
//                 <Button
//                   color="secondary"
//                   className="modalCloseBtn"
//                   onClick={this.openAiToggle}
//                 >
//                   Close
//                 </Button>
//               </ModalFooter>
//             </Modal>
//           )}

//           {this.props.data && (
//             <div className="result-popup-btn m-0 p-0 d-flex align-items-center justify-content-center pmw-outer-wrapper">
//               {this.props.question?.isVideo && (
//                 <a
//                   href="javascript:void(0)"
//                   className="outline-btn ml-3 mr-6px me-3"
//                   onClick={this.showVideoModal}
//                 >
//                   Explanation (English)
//                 </a>
//               )}
//               <div className="left-btns">
//                 <a
//                   href="javascript:void(0)"
//                   className="outline-btn"
//                   onClick={(e) => {
//                     console.log("this.props.id",this.props.id);

//                     this.showScore(e, this.props.id)}}
//                 >
//                   View scores with remarks
//                 </a>
//               </div>
//             </div>
//           )}

//           {this.state.videoModal && (
//             <QuestionExplanationVideo
//               isOpen={this.state.videoModal}
//               toggle={this.closeVideoModal}
//               videoUrl={this.props.question.video}
//             />
//           )}

//           {this.state.showBottomExplanationPopup && (
//             <ModalSkeleton
//               status={this.state.showBottomExplanationPopup}
//               toggle={() =>
//                 this.setState({ showBottomExplanationPopup: false })
//               }
//               handleClick={() => {
//                 this.props.history.push("/admin/sub/payment/form/37");
//               }}
//               btnText="Buy Plan"
//               message="Please subscribe to our gold plan to see Explanation Video"
//               isSmall={false}
//             />
//           )}
//         </>
//       );
//     }

//     return (
//       <>
//         <Row>
//           {this.state.modal && (
//             <Modal isOpen={this.state.modal} size="lg">
//               <ModalBody>
//                 <Table>
//                   <tbody>
//                     <tr>
//                       <th>Component</th>
//                       <th>Score</th>
//                       <th>Remarks</th>
//                     </tr>
//                     {this.showHistoryFunc().map((v) => {
//                       return ReactHtmlParser(v);
//                     })}
//                   </tbody>
//                 </Table>
//                 <div>{this.otherData()}</div>
//               </ModalBody>
//               <ModalFooter>
//                 <Button
//                   color="secondary"
//                   className="modalCloseBtn"
//                   onClick={this.toggle}
//                 >
//                   Close
//                 </Button>
//               </ModalFooter>
//             </Modal>
//           )}
//           <Col xs={12}>
//             <div>
//               <CardBody>
//                 <Table>
//                   <thead className="text-primary">
//                     <tr></tr>
//                   </thead>
//                   <tbody>
//                     {this.props.data.map((val, key) => {
//                       if (val.user.length === 0) {
//                         return false;
//                       }
//                       return (
//                         <tr>
//                           {[1, 2, 3, 5].includes(val.type) && (
//                             <React.Fragment>
//                               {" "}
//                               <td>
//                                 <h3 className="comment-user">
//                                   <img
//                                     style={{
//                                       width: "57px",
//                                       height: "57px",
//                                       borderRadius: "41px",
//                                     }}
//                                     src={
//                                       val.user[0].image
//                                         ? base + val.user[0].image
//                                         : "data:image/jpeg;base64,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"
//                                     }
//                                   />
//                                   &nbsp;&nbsp;{val.user[0].first_name}
//                                 </h3>
//                                 <div>
//                                   <small>{val.aus_date + " (AEDT)"}</small>
//                                 </div>
//                                 Score :{" "}
//                                 {Math.round(
//                                   val.score.reduce(
//                                     (sum, key) => sum + parseFloat(key.score),
//                                     0
//                                   )
//                                 ) +
//                                   "/" +
//                                   val.score.reduce(
//                                     (sum, key) => sum + parseFloat(key.from),
//                                     0
//                                   )}
//                               </td>
//                               <td>
//                                 <audio
//                                   src={s3base + "/ptedata/ptemedia/" + val.file}
//                                   controls="controls"
//                                 />
//                                 <div>
//                                   <Button
//                                     color="primary"
//                                     className="viewResultbtn"
//                                     onClick={(e) => this.showScore(e, val.id)}
//                                     size="sm"
//                                   >
//                                     View
//                                   </Button>
//                                   {store.getState().user.id === val.user_id && (
//                                     <Button
//                                       onClick={(e) =>
//                                         this.deleteComment(e, val.id)
//                                       }
//                                       className="btn delete-btn"
//                                     >
//                                       Delete
//                                     </Button>
//                                   )}
//                                 </div>
//                               </td>
//                             </React.Fragment>
//                           )}
//                           {[8, 9, 10, 14, 15, 17, 18, 4].includes(val.type) && (
//                             <React.Fragment>
//                               <td>
//                                 <h3 className="comment-user">
//                                   <img
//                                     style={{
//                                       width: "57px",
//                                       height: "57px",
//                                       borderRadius: "41px",
//                                     }}
//                                     src={
//                                       val.user[0].image
//                                         ? base + val.user[0].image
//                                         : "data:image/jpeg;base64,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"
//                                     }
//                                   />
//                                   &nbsp;&nbsp;{val.user[0].first_name}
//                                 </h3>
//                                 <div>
//                                   <small>{val.aus_date + " (AEDT)"}</small>
//                                 </div>
//                                 Score :{" "}
//                                 {val.score.reduce(
//                                   (sum, key) => sum + parseFloat(key.score),
//                                   0
//                                 ) +
//                                   "/" +
//                                   val.score.reduce(
//                                     (sum, key) => sum + parseFloat(key.from),
//                                     0
//                                   )}
//                               </td>
//                               <td>
//                                 {ReactHtmlParser(val.html)}
//                                 <br />

//                                 <Button
//                                   className="viewResultbtn"
//                                   onClick={(e) => this.showScore(e, val.id)}
//                                   size="sm"
//                                 >
//                                   View
//                                 </Button>
//                                 {store.getState().user.id === val.user_id && (
//                                   <Button
//                                     onClick={(e) =>
//                                       this.deleteComment(e, val.id)
//                                     }
//                                     className="btn delete-btn"
//                                   >
//                                     Delete
//                                   </Button>
//                                 )}
//                                 <div> </div>
//                               </td>
//                             </React.Fragment>
//                           )}
//                           {[11, 12, 20, 19, 16, 6, 7, 13].includes(
//                             val.type
//                           ) && (
//                             <React.Fragment>
//                               <td>
//                                 <h3 className="comment-user">
//                                   <img
//                                     style={{
//                                       width: "57px",
//                                       height: "57px",
//                                       borderRadius: "41px",
//                                     }}
//                                     src={
//                                       val.user[0].image
//                                         ? base + val.user[0].image
//                                         : "data:image/jpeg;base64,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"
//                                     }
//                                   />
//                                   &nbsp;&nbsp;{val.user[0].first_name}
//                                 </h3>
//                                 <div>
//                                   <small>{val.aus_date + " (AEDT)"}</small>
//                                 </div>
//                                 Score :{" "}
//                                 {val.score.reduce(
//                                   (sum, key) => sum + parseFloat(key.score),
//                                   0
//                                 ) +
//                                   "/" +
//                                   val.score.reduce(
//                                     (sum, key) => sum + parseFloat(key.from),
//                                     0
//                                   )}
//                               </td>
//                               <td>
//                                 {ReactHtmlParser(val.answer)}
//                                 <br />

//                                 <Button
//                                   color="primary"
//                                   className="viewResultbtn"
//                                   onClick={(e) => this.showScore(e, val.id)}
//                                   size="sm"
//                                 >
//                                   View
//                                 </Button>
//                                 {store.getState().user.id === val.user_id && (
//                                   <Button
//                                     onClick={(e) =>
//                                       this.deleteComment(e, val.id)
//                                     }
//                                     className="btn delete-btn"
//                                   >
//                                     Delete
//                                   </Button>
//                                 )}
//                                 <div> </div>
//                               </td>
//                             </React.Fragment>
//                           )}
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </Table>
//               </CardBody>
//             </div>
//           </Col>
//         </Row>
//       </>
//     );
//   }
// }

// export default ShowHistoryData;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Table, Row, Col, Button, Modal } from "react-bootstrap"
import API from "api.js";
import { base, s3base } from "api.js";
import ReactHtmlParser from "react-html-parser";
import { setAlert } from "action/index.js";
import { store } from "store/index";
import ModalSkeleton from "components/PopUps/ModalSkeleton";
import Content from "/public/images/popup-icons/Content.png";
import Pronunciation from "/public/images/popup-icons/pronoun.png";
import Fluency from "/public/images/popup-icons/checkboxGreen.png";
import BarFrequency from "/public/images/popup-icons/popupBar.png";
import Grammar from "/public/images/popup-icons/Grammar.png";
import Vocabulary from "/public/images/popup-icons/Vocabulary.png";
import FormIcon from "/public/images/popup-icons/Form.png";
import linguistic from "/public/images/popup-icons/linguistic-icon.png";
import Structure from "/public/images/popup-icons/structure-icon.png";
import Score from "/public/images/popup-icons/Score-icon.png";
// import QuestionExplanationVideo from "components/PopUps/QuestionExplanationVideo";

const ShowHistoryData = (props) => {
  const [modal, setModal] = useState(false);
  const [id, setId] = useState(0);
  const [openAiModal, setOpenAiModal] = useState(false);
  // const [paragraphExplainationModal, setParagraphExplainationModal] = useState(false);
  const [showBottomExplanationPopup, setShowBottomExplanationPopup] = useState(false);
  // const [videoModal, setVideoModal] = useState(false);
  const isSubscribed = props.user?.active_subscription?.length > 0;
  const navigate = useNavigate();

  const showScore = (e, id) => {
    props.hideParent && props.hideParent();
    setModal(!modal);
    setId(id);
  };

  const showOpenAiScore = (e) => {
    setOpenAiModal(!openAiModal);
  };

  // const showExplanation = () => {
  //   setParagraphExplainationModal(true);
  // };

  const deleteComment = async (e, id) => {
    const bodyFormData = { id: id, question_id: props.question };
    let res = null;
    try {
      res = await API({
        method: "Delete",
        url: "delete/question/response",
        data: bodyFormData,
      });
    } catch (error) {
      console.error("Delete commment error", error)
    }

    if (res) {
      if (res.status === 200) {
        props.changeResponseArr(res.data.data);
        store.dispatch(
          setAlert({ flag: true, type: 1, message: res.data.message })
        );
      }
    }
  };
console.log(props.data[0].type);
  // const showHistoryFunc = () => {
  //   if (!props.data || !Array.isArray(props.data)) {
  //     console.error("Expected an array for props.data but got:", props.data);
  //     return [];
  //   }

  //   let arr = props.data;

  //   if (!Array.isArray(arr)) {
  //     console.error("Expected an array, but got:", arr);
  //     return [];
  //   }
  //   let arr1 = arr.filter((va) => typeof va === "object");
  //   let a = arr1.map((v) => {
  //     return `
  //       <tr>
  //         <td>${remarks(v.type)}</td>
  //         <td className="result-score-wrapper">
  //           <span>${v.score}/${v.from}</span>
  //         </td>
  //         <td>${v.remarks}</td>
  //       </tr>
  //     `;
  //   });
  //   if ([6, 7, 13].includes(props.data[0].type)) {
  //     let t_from = 0;
  //     let t_score = 0;
  //     for (let i = 0; i <= arr1.length - 1; i++) {
  //       t_from += arr1[i].from;
  //       t_score += arr1[i].score;
  //     }
  //     a.push(
  //       '<tr><td>Total</td><td colspan="2">' +
  //       t_score +
  //       "/" +
  //       t_from +
  //       "</td></tr>"
  //     );
  //   }
  //   return a;
  // };

  const showHistoryFunc = () => {

  if (!props.data || !Array.isArray(props.data)) {
      console.error("Expected an array for props.data but got:", props.data);
      return [];
  }

  const arr1 = props.data.filter((va) => typeof va === "object");

  let totalScore = 0;
  let totalFrom = 0;
  
  const rows = arr1.map((v) => {
    totalScore += v.score;
    totalFrom += v.from;

    const iconSrc = getIconByType(v.type) || "/icons/default.svg";

    // remarks list
    const remarksList = `<li class="mx-3">${v.remarks}</li>`;

    return `
      <div class="performance-item">
        <div class="item-header">
          <div class="item-title">
            <img src="${iconSrc}" alt="${remarks(v.type)}" style="max-height:30px;" />
            <span>${remarks(v.type)}</span>
          </div>

          <span class="score">${v.score}/${v.from}</span>
        </div>

        <ul>
          ${remarksList}
        </ul>
      </div>
    `;
  }); 

  // total row (for specific question types)
  if([1,2,3,4,21,22].includes(props.question.subcategory_id)) {
			totalFrom = totalFrom / arr1.length;
      totalScore = totalScore / arr1.length;
      rows.push(`
        <div class="performance-item total">
          <div class="item-header">
            <div class="item-title">
              <span>Total</span>
            </div>
            <span class="score fw-bold">${Math.round(totalScore)}/${totalFrom}</span>
          </div>
        </div>
      `);
		}else{
      rows.push(`
        <div class="performance-item total">
          <div class="item-header">
            <div class="item-title">
              <span>Total</span>
            </div>
            <span class="score fw-bold">${totalScore}/${totalFrom}</span>
          </div>
        </div>
      `);
    }
  // if ([6, 7, 13].includes(props.data[0].type)) {}

  return rows;
};

  const remarks = (type) => {
    let str = "";
    switch (type) {
      case 0:
        str = "Content";
        break;
      case 1:
        str = "Fluency";
        break;
      case 2:
        str = "Pronunciation";
        break;
      case 3:
        str = "Score";
        break;
      case 4:
        str = "Grammar";
        break;
      case 5:
        str = "Form";
        break;
      case 6:
        str = "Vocabulary";
        break;
      case 7:
        str = "Spelling";
        break;
      case 8:
        str = "Structure";
        break;
      case 9:
        str = "Linguistic range";
        break;
      default:
        str = "";
    }
    return str;
  };

  const getIconByType = (type) => {
      switch (type) {
        case 0:
          return Content;
  
        case 1:
          return Fluency;
  
        case 2:
          return Pronunciation;
  
        case 3:
          return Score;
  
        case 4:
          return Grammar;
  
        case 5:
          return FormIcon;
  
        case 6:
          return Vocabulary;
  
        case 7:
          return BarFrequency;
  
        case 8:
          return Structure;
  
        case 9:
          return linguistic;
  
        default:
          return "";
    }
  };

  const otherData = () => {
    let arr = props.data.map((v) => {
      if (id === v.id) {
        return v.score;
      }
    });
    let data = props.data
      .map((v) => {
        if (id === v.id) {
          return v;
        }
      })
      .filter((va) => {
        if (typeof va === "object") {
          return va;
        }
      })[0];
    let arr1 = arr.filter((va) => {
      if (typeof va === "object") {
        return va;
      }
    })[0];
    let a = arr1.map((v) => {
      return `<tr><td>${remarks(v.type)}</td><td>${v.score}/${v.from}</td><td>${v.remarks
        }</td></tr>`;
    });
    console.error(data);
    return (
      <div className="mt-4 text-center">
        <h3>User Response</h3>
        {data.html != "undefined" &&
          data.type != 10 &&
          ReactHtmlParser(data.html)}
        {data.html != "undefined" &&
          data.type == 10 &&
          data.html
            .split("<br />")
            .filter((va) => {
              if (va !== "") {
                return va;
              }
            })
            .map((v) => {
              return ReactHtmlParser(
                '<li className="list-group-item1">' + v + "</li>"
              );
            })}

        {[3, 4].includes(data.type) && (
          <div>
            <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW">
              <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>
                Good
              </div>
              <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJav"></div>
                Average
              </div>
              <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca"></div>
            </div>
          </div>
        )}
        {[1, 2].includes(data.type) && (
          <div>
            <div className="AIScoreCom__Category-sc-1yzm0aw-12 liAXDW">
              <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJgd"></div>
                Good
              </div>
              <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca">
                <div className="AIScoreCom__Circle-sc-1yzm0aw-10 iyKrJbad"></div>
                Bad pronunciation/Missed words
              </div>
              <div className="AIScoreCom__CategoryItem-sc-1yzm0aw-11 ffgUca"></div>
            </div>
          </div>
        )}
        {[6, 7, 13, 11, 12, 16, 19].includes(data.type) &&
          ReactHtmlParser(data.answer)}
        {data.file && (
          <div>
            <audio
              className="mt-4"
              src={s3base + "/ptedata/ptemedia/" + data.file}
              controls="controls"
            />
          </div>
        )}
      </div>
    );
  };

  const toggle = () => {
    setModal(!modal);
    props.showParent && props.showParent();
  };

  const openAiToggle = () => {
    setOpenAiModal(!openAiModal);
  };

  const itemLabel = (key) => {
    const labels = {
      content: "Content",
      form: "Form",
      grammar: "Grammar",
      vocabulary: "Vocabulary",
      linguistic: "Linguistic Range",
      structure: "Structure",
      spelling: "Spelling",
      overall: "Overall Score",
    };

    return labels[key];
  };

  const showRemarksWithFeedback = () => {
    const { feedback } = props.openAiRemarks;

    if (feedback !== undefined && feedback !== null) {
      let html = "";
      Object.keys(feedback).map((key, i) => {
        const score = props.openAiRemarks[key].score;
        const out_of = props.openAiRemarks[key].out_of;

        html += "<tr>";
        html += `<td>${itemLabel(key)}</td>`;
        html += `<td>${score}/${out_of}</td>`;
        html += `<td>${feedback[key]}</td>`;
        html += "</tr>";
      });
      return ReactHtmlParser(html);
    }
  };

  // const closeVideoModal = () => {
  //   setVideoModal(false);
  // };

  // const showVideoModal = () => {
  //   if (props.question.video) {
  //     setVideoModal(true);
  //   } else {
  //     setShowBottomExplanationPopup(true);
  //   }
  // };

  if (props.flag === 1) {
    return (
      <>
        {modal && (
          <Modal show={modal} size="lg" centered className="score-popup">
            <Modal.Header className="d-flex">
              <Modal.Title className="text-translation popup_heading m-0">
              Score with remarks
              </Modal.Title>
    
              <Button variant="link" className="modalClose-Btn p-0" onClick={toggle}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path
                d="M18 6L6 18M6 6l12 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                />
              </svg>
              </Button>
            </Modal.Header>
            <Modal.Body>
              {/* <Table>
                <tbody>
                  <tr>
                    <th>Component</th>
                    <th>Score</th>
                    <th>Remarks</th>
                  </tr>
                </tbody>
              </Table> */}
                  {modal && (
                    <>
                      {showHistoryFunc().map((v) => {
                        return ReactHtmlParser(v);
                      })}
                      {props.showBackButton && 
                       <button
                        className="outline-btn"
                        onClick={() => {
                          setModal(false);
                          props.showParent && props.showParent();
                        }}
                      >
                        Back
                      </button>
                      }
                    </>
                  )}
            </Modal.Body>
          </Modal>
        )}

        {openAiModal && (
          <Modal show={openAiModal} centered size="lg">
            <Modal.Body>
              <Table>
                <tbody>
                  <tr>
                    <th>Component</th>
                    <th>Score</th>
                    <th>Remarks</th>
                  </tr>
                  {showRemarksWithFeedback()}
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer className="justify-content-start">
              <Button
                color="secondary"
                className="modalCloseBtn"
                onClick={openAiToggle}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        {props.data && (
          <div className="result-popup-btn m-0 p-0 d-flex align-items-center justify-content-start pmw-outer-wrapper">
            {/* {props.question?.isVideo && ( <button className="outline-btn ml-3 mr-6px me-3" onClick={showVideoModal} >Full Paragraph Explanation</button>)} */}
           <div className="d-flex justify-content-between align-items-center w-100 pb-2">
            {[11, 12].includes(parseInt(props.type)) && isSubscribed && (
              <button
                className="outline-btn ml-3 mr-6px me-3"
                onClick={() => props.showExplanation()}
              >
                Full Paragraph Explanation
              </button>
            )}

             {[11, 12].includes(parseInt(props.type)) && !isSubscribed && (
    <button
      style={{opacity: 0.6,
           cursor: "pointer"}}
      className="outline-btn ml-3 mr-6px me-3 disabled-btn"
      onClick={() => setShowBottomExplanationPopup(true)}
    >
      Full Paragraph Explanation 🔒
    </button>
  )}
             <div className="left-btns">
              <button
                className="outline-btn"
                onClick={(e) => {
                  showScore(e, props.id);
                }}
              >
                View scores with remarks
              </button>
            </div>
              {props.speed_percentage !== null && props.speed_percentage !== undefined && (
							<span className="px-1">Speed: <span className={props.speed_percentage === "Too Slow" ? "color-danger" : (props.speed_percentage === "Too Fast" ? "color-warning" : "color-success")}>{props.speed_percentage}</span>
							</span>
						)}
           </div>
          </div>
        )}

        {/* {videoModal && (
          <QuestionExplanationVideo
            isOpen={videoModal}
            toggle={closeVideoModal}
            videoUrl={props.question.video}
          />
        )} */}

        {showBottomExplanationPopup && (
          <ModalSkeleton
            status={showBottomExplanationPopup}
            toggle={() => setShowBottomExplanationPopup(false)}
            handleClick={() => {
              navigate("/admin/plans");
            }}
            btnText="Buy Plan"
            message="Please subscribe to our plan to see Explanation"
            isSmall={false}
          />
        )}
      </>
    );
  }

  return (
    <>
      <Row>
        {modal && (
          <Modal show={modal} centered size="lg">
            <Modal.Body>
              {/* <Table>
                <tbody>
                  <tr>
                    <th>Component</th>
                    <th>Score</th>
                    <th>Remarks</th>
                  </tr>
                </tbody>
              </Table> */}
                  {showHistoryFunc().map((v) => {
                    return ReactHtmlParser(v);
                  })}
              <div>{otherData()}</div>
            </Modal.Body>
            <Modal.Footer className="justify-content-start">
              <div className="d-flex gap-2">
               <button
                className="outline-btn"
                onClick={() => {
                  setModal(false);
                  props.showParent && props.showParent();
                }}
              >
                Back
              </button>
              <Button
                variant="secondary"
                className="modalCloseBtn"
                onClick={toggle}
              >
                Close
              </Button>
              </div>
            </Modal.Footer>
          </Modal>
        )}
        <Col xs={12}>
          <div>
            <Card.Body>
              <Table>
                <thead className="text-primary">
                  <tr></tr>
                </thead>
                <tbody>
                  {props.data.map((val, key) => {
                    if (val.user.length === 0) {
                      return false;
                    }
                    return (
                      <tr key={key}>
                        {[1, 2, 3, 5].includes(val.type) && (
                          <React.Fragment>
                            {" "}
                            <td>
                              <h3 className="comment-user">
                                <img
                                  style={{
                                    width: "57px",
                                    height: "57px",
                                    borderRadius: "41px",
                                  }}
                                  src={
                                    val.user[0].image
                                      ? base + val.user[0].image
                                      : "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAMAAACahl6sAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAAMAUExURevr7Jydn5manJucnuPj5JiZm9vb3PT09MvLzMLCw5GSlPr6+qeoqdXV1tHR0rW1trW2uKusrbi4urO0tLq6vKiqq7e4uLW2tqGipLm6ury8vr6+vr+/wLu8vM7OztDQ0cjJytjY2dTU1aipqqqrrMXGxqanqKmqq6Wmp9LT062usKSlprS0ta2trra2t6ytrqWmqK2ur66vsK6ur7CwsbOztK+vsK+wsbKys7GxsqOkpqOkpZ6foampq6qqrJ2eoKenqaysraKjpZqbnbi4uaKjpKSlp5eYmqioqqurrKChory8vKGio6amqKCho7Gys7CxsrGysrKzs5+gop+gobS1tbq6u7e3uLCxsbKztLi4uJWWmJaXmba3t7i5ub29vZWXmZSWmLq6upOVl5SVl7m5up6foLq7u7u7vJqcnZOUlpeZm5aYmpKUlry8vZKTlpGTlZCRlJCRk6ytr9bX197e3q+vsb2+v8DAweDh4bOztebm5ujp6e/v756eoP///4CAgIGBgYKCgoODg4SEhIWFhYaGhoeHh4iIiImJiYqKiouLi4yMjI2NjY6Ojo+Pj5CQkJGRkZKSkpOTk5SUlJWVlZaWlpeXl5iYmJmZmZqampubm5ycnJ2dnZ6enp+fn6CgoKGhoaKioqOjo6SkpKWlpaampqenp6ioqKmpqaqqqqurq6ysrK2tra6urq+vr7CwsLGxsbKysrOzs7S0tLW1tba2tre3t7i4uLm5ubq6uru7u7y8vL29vb6+vr+/v8DAwMHBwcLCwsPDw8TExMXFxcbGxsfHx8jIyMnJycrKysvLy8zMzM3Nzc7Ozs/Pz9DQ0NHR0dLS0tPT09TU1NXV1dbW1tfX19jY2NnZ2dra2tvb29zc3N3d3d7e3t/f3+Dg4OHh4eLi4uPj4+Tk5OXl5ebm5ufn5+jo6Onp6erq6uvr6+zs7O3t7e7u7u/v7/Dw8PHx8fLy8vPz8/T09PX19fb29vf39/j4+Pn5+fr6+vv7+/z8/P39/f7+/v///zfARREAAAeqSURBVHja7N3xVxJZFMBxQAQVilzPSTslBxcDdwdtBQRBDQUFBYNMDTcoNLAMM7QD23JozvvX94cJZBhQZ+bdO2/26F/Q59wv8K48JwP5n/wY7iH3kHvIPYT6D89bLBazfiF8Y+T09PT09MOHzc3Nd+8yeoTwb99+/PjkSbfj8eN83qYPSCOTOTs7O3veEP69UkcegEIdMpPJCI6zz5/f9p9HPp9//97KMsTwLZO5o2Nh4RmrkHrpmxzHwsICzyLEWSq1IXd1TE6aWYNYSqVSqSRzHpOTDsdDliC2ksBQ4HA4zOxA6iURRJ7DccizAbE9fVpyNXhlXTkcjsNDHxMQKyGEWBV35Tg89Pl8rKTVUtHVoc/n89mYgPBK3686Dt8EIcQwMzOjKUTF+1XHMbG0tLT095s3y8vL77WCqHq/Ehy+Lsdybm9aC4irRKGrLkcut7cXiUTQIS1588jfPo/cXiQSibxGhtTpdyU4kCElyq/zXMdx9AwT0qI+j1zbEQwiQmyUX+fXXR0Fg0EXGsQK1dXRUTAYDIbRIJBdBYNhNIgFsqtgOBx2IkFguwqHQyEcSAu2q3AICwLcVSjEh1oYEPCuQgbix4A4obsK+QmPAwHtKhTy+3+gvEacsF2F/H5/wIAIAevK7/cHAhgQgPNuzzwCgcAiFgSoK3/bgQWhuUdJuwosYkGgu1pcnDdgQCju5wPmMY8CAeyqPY/5+To8BKErPAjY50fb8QIHAnIu6Z7HCxwI0Lmk24ECge8KB4LQ1YuNDYS3X4SuNjbGESAIXW2M40DAuxofH0c4ayF0hQNB6AoJAt8VDgShq/GdHQwIYFfteezMIkCgzrsiBwZkhPp+LulqFgXyB/X9XDoPFEgTviscCE99P+/+/PjlwIAQ6vu5dB4vX2JAALvaaTu8OBCoc0m7q5deHAjYuaQzD68fAwJ3Luk4vC4MyAh4V17vAwxIE7orr9fLY0AIdFde7xpBg8B09cuBCAHtyrvmxoLAdrXm/h0DUgfvas3tdvPQEBdCV2632+3eHgWFwL9ftR12+yYg5CfIfi7pyu3ettvtdkAI2B4lnYfdbndBQiD28wGO9XUwiAFmP5e8zu0CxGOFgrgQu1pf93hcUJA84HlX/DoXIDkoCNB+3r8rj8fjgYIA7ef9u4KGoHXl8XheAUKAzyXdXXlezcFBwM8lXV29moODoHY1BwfB7QoSgtoVIARuj+rXFTAEtCvxPJKPoCBm1K6SyZ9gx3jorrodc0kObh/B7CrJzQJCELviZA1EJsQAtp9LuwKFENA9SjwPbhoSYgbbzwVGl0PeQGT/gg5sP+/tipuFhRCkruQORD5kFPa8qzAsJb/Ehj3v/uqKM8NDSANmPxd11cD5fgS8K5Q/3yOE2L7l9vYWALpKPuI4jsP7M3DhB+JcovyBbmoeJ0K/K45oASG0u0py09pAND7v0oM0qe7nSU4zCKG7R2kJofw5yGsFcVLcz1UOROXztah2pSWE6vkqatUO0qS2n3McFyXaQYiP2h6l0qH6qYCU9nMuGmUBon6P4qLRh9pCrJS6UjsQ9Q+cXKKwR3HRaPQfrSGESlfRFaI5pK7284OKg8aDiyl0tcIEpKV4j6LooPIoaYParlZ4NiBE2X5+7fiXMAIh6rpaIcxAeDVdUXHQem78A/n7ecfRYAlCphXsURTnQfG/JJC/RwkO9iCy9yjBEWcNoqyrlTiTEPldxZmEKOgqHt9iDyL782MlHo9vsQeRtZ9fO5iDyNyjOg72IIq62tqaYg0ib4+6drAJkd3VFJMQBV1NTe2yC5HTFZOQO+9R3fPYZQ4iu6spwcEq5PY9StTV7m6WLYjtVFlXu9nsCDMQi9+ruKtsNptOp9N/WTWHmJ/I2s8l88im0+n0/v7+Qc6mHcSiZI8a4Dg4OFhdVXGnRjHks9I9StpVx7G6uvrpU8yJCHmudD+/cR6CIxaLxR5gQJT/3ufOjljMaDQ6ASHN18q+P5fRVcdhNBqNQ9tWAEhL+ffnCuZhNBqNQ0NDQ0N+qpCmyu85lTu+fEkkEnYLDcio6u/PFXbVcSQSiYTJ5FQFeU7le0518xAcJpPJNKMMUqL0/Tk1h2l4eHh4RB6kPkHlHvKA827HsS/bMXx+nvqtdUcItfvt9OcxfH6eSqVSqa8/boU06d2/AnR8LRaLN0Pq9O6339aVckfqa7FYLB7fBKF0DxlhHsXj42PjQEgIqqspCEehUBgA8dG5347S1fFxoVAo2PpCWrrqqlAoFE5OWn0gBr11VTg5Oan0gdC63w45j1Svo2KVQujdQ8bq6qRSqVQkkAlq95DxuqpUKmUJhNb9dsyuKpVyeVQC0WNX5XK52gOx6LKrcrlabYghE5Tut+N2VS5Xq3YxhNo9ZNyuqtXqhQhipXS/HburavVCDKkzvUcN7qp60QPZ1GtXFxc1EYTV/fwaMmgetV4Iu/v5jV3VarW6CML2fj64q1qt9mc3hPX9fPA8ape9ED3sUX3mcXl5KYboY4/q5xgTQdjfz/t31QvRb1djYz0QvXYlhbC/n/ftqgeinz1KMo8eiG72KKlDBNHPHtXbVT+ILrsaG7vqgei0q6ur770QfXZ19V2A/DcAHpmC7NcZ4/wAAAAASUVORK5CYII="
                                  }
                                />
                                &nbsp;&nbsp;{val.user[0].first_name}
                              </h3>
                              <div>
                                <small>{val.aus_date + " (AEDT)"}</small>
                              </div>
                              Score :{" "}
                              {Math.round(
                                val.score.reduce(
                                  (sum, key) => sum + parseFloat(key.score),
                                  0
                                )
                              ) +
                                "/" +
                                val.score.reduce(
                                  (sum, key) => sum + parseFloat(key.from),
                                  0
                                )}
                            </td>
                            <td>
                              <audio
                                src={s3base + "/ptedata/ptemedia/" + val.file}
                                controls="controls"
                              />
                              <div>
                                <Button
                                  color="primary"
                                  className="viewResultbtn"
                                  onClick={(e) => showScore(e, val.id)}
                                  size="sm"
                                >
                                  View
                                </Button>
                                {store.getState().user.id === val.user_id && (
                                  <Button
                                    onClick={(e) => deleteComment(e, val.id)}
                                    className="btn delete-btn"
                                  >
                                    Delete
                                  </Button>
                                )}
                              </div>
                            </td>
                          </React.Fragment>
                        )}
                        {[8, 9, 10, 14, 15, 17, 18, 4].includes(val.type) && (
                          <React.Fragment>
                            <td>
                              <h3 className="comment-user">
                                <img
                                  style={{
                                    width: "57px",
                                    height: "57px",
                                    borderRadius: "41px",
                                  }}
                                  src={
                                    val.user[0].image
                                      ? base + val.user[0].image
                                      : "data:image/jpeg;base64,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"
                                  }
                                />
                                &nbsp;&nbsp;{val.user[0].first_name}
                              </h3>
                              <div>
                                <small>{val.aus_date + " (AEDT)"}</small>
                              </div>
                              Score :{" "}
                              {val.score.reduce(
                                (sum, key) => sum + parseFloat(key.score),
                                0
                              ) +
                                "/" +
                                val.score.reduce(
                                  (sum, key) => sum + parseFloat(key.from),
                                  0
                                )}
                            </td>
                            <td>
                              {ReactHtmlParser(val.html)}
                              <br />

                              <Button
                                className="viewResultbtn"
                                onClick={(e) => showScore(e, val.id)}
                                size="sm"
                              >
                                View
                              </Button>
                              {store.getState().user.id === val.user_id && (
                                <Button
                                  onClick={(e) => deleteComment(e, val.id)}
                                  className="btn delete-btn"
                                >
                                  Delete
                                </Button>
                              )}
                              <div> </div>
                            </td>
                          </React.Fragment>
                        )}
                        {[11, 12, 20, 19, 16, 6, 7, 13].includes(val.type) && (
                          <React.Fragment>
                            <td>
                              <h3 className="comment-user">
                                <img
                                  style={{
                                    width: "57px",
                                    height: "57px",
                                    borderRadius: "41px",
                                  }}
                                  src={
                                    val.user[0].image
                                      ? base + val.user[0].image
                                      : "data:image/jpeg;base64,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"
                                  }
                                />
                                &nbsp;&nbsp;{val.user[0].first_name}
                              </h3>
                              <div>
                                <small>{val.aus_date + " (AEDT)"}</small>
                              </div>
                              Score :{" "}
                              {val.score.reduce(
                                (sum, key) => sum + parseFloat(key.score),
                                0
                              ) +
                                "/" +
                                val.score.reduce(
                                  (sum, key) => sum + parseFloat(key.from),
                                  0
                                )}
                            </td>
                            <td>
                              {ReactHtmlParser(val.answer)}
                              <br />

                              <Button
                                color="primary"
                                className="viewResultbtn"
                                onClick={(e) => showScore(e, val.id)}
                                size="sm"
                              >
                                View
                              </Button>
                              {store.getState().user.id === val.user_id && (
                                <Button
                                  onClick={(e) => deleteComment(e, val.id)}
                                  className="btn delete-btn"
                                >
                                  Delete
                                </Button>
                              )}
                              <div> </div>
                            </td>
                          </React.Fragment>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Card.Body>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ShowHistoryData;
